import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useColorModeValue,
} from '@chakra-ui/react';
import type { ComponentProps } from 'react';
import ProdutoForm from './ProdutoForm';

type ProdutoFormProps = ComponentProps<typeof ProdutoForm>;

type ProdutoModalProps = Pick<
  ProdutoFormProps,
  'produto' | 'onSincronizar' | 'onAtualizarStatus'
> & {
  isOpen: boolean;
  onClose: () => void;
};

const ProdutoModal = ({
  isOpen,
  onClose,
  produto,
  onSincronizar,
  onAtualizarStatus,
}: ProdutoModalProps) => {
  const fundoModal = useColorModeValue('white', 'gray.800');
  const corTexto = useColorModeValue('gray.800', 'white');
  const corBorda = useColorModeValue('gray.200', 'gray.700');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent
        borderRadius="xl"
        bg={fundoModal}
        color={corTexto}
        borderWidth="1px"
        borderColor={corBorda}
      >
        <ModalHeader color={corTexto}>Detalhes do Produto</ModalHeader>
        <ModalCloseButton color={corTexto} />
        <ModalBody pb={6} color={corTexto}>
          <ProdutoForm
            produto={produto}
            onClose={onClose}
            onSincronizar={onSincronizar}
            onAtualizarStatus={onAtualizarStatus}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ProdutoModal;
